/* eslint-disable react/prop-types */

import { useEffect, useRef, useState, useContext } from 'react';
import { PencilUploadIcon } from '../../assets/svgs/icons';
import styles from './styles.module.css';

import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import companyIcon from '../../assets/imgs/enterprise.png';
import ProgressBar from '../../components/ProgressBar';
import Stepper from '../../components/Stepper';
import {
  // PagarMeService,
  SubscriptionService,
  TimelineActionsService,
  UserAccountsService,
} from '../../services/';

import Masonry from 'react-responsive-masonry';

import ModalComponent from '../../components/ModalComponent';
import { TourGuide } from '../../components/TourGuide';
import { useAuth } from '../../hooks/useAuth';
import { useClient } from '../../hooks/useClient';
import { SettingsService } from '../../services';
import ModalCancelPlan from './ModalCancelPlan';
// import { ProductFruits } from 'react-product-fruits'
import { useTranslation } from 'react-i18next';
import { DashboardContainerSteps } from './TourGuideSteps/DashboardSteps';
import SideMenuMyAccount from '../../components/SideMenuMyAccount';

import NProgress from '../../utils/nprogress';
import { IntlContext } from '../../contexts/IntlContext/IntlContext';
import { InviteLinkComponent } from '../../components/InviteLinkComponent';
import { getCurrentSubscription } from '../../utils/subscription';

const buildFeatureData = (
  subscriptionFeaturesResponse,
  userSubscriptionsResponse,
  userPlan,
) => {
  const subscriptionFeatures = subscriptionFeaturesResponse?.data ?? {};
  const userSubscriptions = Array.isArray(userSubscriptionsResponse?.data)
    ? userSubscriptionsResponse.data
    : [];
  const totalSinglePostLimit =
    Number(subscriptionFeatures.singlePostLimit ?? 0) +
    Number(subscriptionFeatures.additionalSinglePostQuantity ?? 0);
  const hasPaidPlanInSession =
    Boolean(userPlan) && String(userPlan).toLowerCase() !== 'free';
  const currentSubscription = getCurrentSubscription(userSubscriptions);
  const hasCurrentPaidSubscription =
    Number(
      currentSubscription?.Plan?.tier ?? currentSubscription?.plan?.tier ?? 0,
    ) > 0;

  return {
    postQuantity: subscriptionFeatures.postQuantity ?? 0,
    postQuantityLimit: subscriptionFeatures.postLimit,
    userQuantity: subscriptionFeatures.userQuantity ?? 0,
    userQuantityLimit: subscriptionFeatures.userLimit,
    schedullingQuantity: subscriptionFeatures.schedullingQuantity ?? 0,
    schedullingQuantityLimit: subscriptionFeatures.unlimitedScheduling
      ? 'Ilimitado'
      : subscriptionFeatures.schedullingLimit,
    clientQuantity: subscriptionFeatures.clientQuantity ?? 0,
    clientQuantityLimit: subscriptionFeatures.clientLimit,
    productQuantity: subscriptionFeatures.productQuantity ?? 0,
    productQuantityLimit: subscriptionFeatures.productLimit,
    targetAudienceQuantity: subscriptionFeatures.targetAudienceQuantity ?? 0,
    targetAudienceQuantityLimit: subscriptionFeatures.targetAudienceLimit,
    aiGenerativeQuantity: subscriptionFeatures.aiGenerativeQuantity ?? 0,
    aiGenerativeQuantityLimit: subscriptionFeatures.aiGenerativeLimit,
    imageBankQuantity: subscriptionFeatures.imageBankQuantity ?? 0,
    imageBankQuantityLimit: subscriptionFeatures.ImageBankLimit,
    legendQuantity: subscriptionFeatures.legendQuantity ?? 0,
    legendQuantityLimit: subscriptionFeatures.legendLimit,
    artGenerationCount: subscriptionFeatures.artGenerationCount ?? 0,
    SinglePostLimit: totalSinglePostLimit,
    campaignTrialAvailable: subscriptionFeatures.campaignTrialAvailable ?? true,
    isFreeOrNoPlan: subscriptionFeatures.isFreeOrNoPlan ?? false,
    unlimitedScheduling: subscriptionFeatures.unlimitedScheduling ?? false,
    showCampaignCounter:
      !hasCurrentPaidSubscription &&
      !hasPaidPlanInSession &&
      subscriptionFeatures.allowSinglePostGeneration !== true &&
      totalSinglePostLimit <= 0,
  };
};

function Settings() {
  const { t } = useTranslation();
  const { userPlan } = useAuth();

  const { country } = useContext(IntlContext);

  const [companyData, setCompanyData] = useState({
    companyName: '',
    companyEmail: '',
    companyPlan: '',
    companyValue: '',
    companyPeriod: '',
  });
  const [featureData, setFeatureData] = useState({
    // postQuantity: 3,
    // postQuantityLimit: 30,
    // userQuantity: 0,
    // userQuantityLimit: 1,
    // schedullingQuantity: 14,
    // schedullingQuantityLimit": 120,
    // clientQuantity: 1,
    // clientQuantityLimit: 2,
    // integrationQuantity: 1,
    // integrationQuantityLimit: 2
  });

  const [userImageData, setUserImageData] = useState([]);

  const [nameCredCard, setNameCredCard] = useState('');

  const [validateCredCard, setValidateCredCard] = useState('');
  const [cvvCredCard, setCvvCredCard] = useState('');
  const [timelineActionData, setTimelineActionData] = useState([]);

  const [percentStep, setPercentStep] = useState(0);

  const [completedStepParametrization, setCompletedStepParametrization] =
    useState(false);
  const [completedStepAddClients, setCompletedStepAddClients] = useState(false);
  const [completedStepAddTeamMembers, setCompletedStepAddTeamMembers] =
    useState(false);
  const [completedStepCreateCampaign, setCompletedStepCreateCampaign] =
    useState(false);
  const [completedStepAddNewPost, setCompletedStepAddNewPost] = useState(false);
  const [completedOwnSchedule, setCompletedOwnSchedule] = useState(false);
  const [completedSinglePost, setCompletedSinglePost] = useState(false);

  const { clientData } = useClient();

  const [userAcount, setUserAccount] = useState();

  const [isModalOpen, setModalOpen] = useState(false);
  const [numberCredCard, setNumberCredCard] = useState('');
  const [numberCredCardValue, setNumberCredCardValue] = useState('');
  const [flagCard, setFlagCard] = useState('');
  const [flagCardLabel, setFlagCardLabel] = useState('');
  const inputRef = useRef(null);
  const [logradouroCard, setlogradouroCard] = useState('');
  const [zipCodeCard, setZipCodeCard] = useState('');
  const [cityCard, setCityCard] = useState('');
  const [stateIdCard, setStateIdCard] = useState('');
  const [countryCard, setCountryCard] = useState(null);
  const [stateData, setStateData] = useState([]);
  const [useUserAddress, setUseUserAddress] = useState(false);

  useEffect(() => {
    loadData();
    // loadCardData()
  }, []);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [numberCredCard]); // Mantém o foco ao atualizar o valor

  useEffect(() => {
    if (zipCodeCard) {
      const cepModified = zipCodeCard.replace(/\D/g, '');
      if (cepModified.length === 8) getAddress(cepModified);
    }
  }, [zipCodeCard]);

  const handleEnable = async () => {
    if (useUserAddress) {
      setUseUserAddress(false);
      setCityCard('');
      setStateIdCard('');
      setlogradouroCard('');
      setZipCodeCard('');
    } else {
      setUseUserAddress('true');
      const user = await UserAccountsService.getUserAccountsByLogin();

      if (user) {
        setCityCard(user.data.city);
        setStateIdCard(user.data.state);
        setlogradouroCard(user.data.logradouro);
        setZipCodeCard(user.data.cep);
      }
    }
  };

  const getAddress = async (cep) => {
    try {
      setZipCodeCard(cep);
      const url = `https://viacep.com.br/ws/${cep}/json/`;
      const options = {
        method: 'GET',
        mode: 'cors',
        headers: {
          'content-type': 'application/json;charset=utf-8',
        },
      };
      const result = await fetch(url, options);
      const endereco = await result.json();

      if (!endereco.erro) {
        const end = `${endereco.logradouro}, ${endereco.bairro}`;
        setlogradouroCard(end);
        setCityCard(endereco.localidade);
        stateData?.map((item) => {
          if (item.sigla === endereco.uf) setStateIdCard(item.id);
        });
      }
    } catch (e) {
      return null;
    }
  };

  const loadCardData = async () => {
    if (clientData?.uuid) {
      // console.log(clientData)
      // const { data: dataAccount, responseStatus: responseStatusAccount } =
      //   await UserAccountsService.getUserAccountsByLogin()
      const dataCard = { data: [] };
      // const dataCard = await PagarMeService.getCardByUser();

      setLoadingUserData(false);
      // console.log("dataCard", dataCard);

      if (dataCard.data) {
        setNumberCredCard(dataCard?.data[0]?.number);
        setNumberCredCardValue(dataCard?.data[0]?.number);
        setNameCredCard(dataCard?.data[0]?.cardName);
        setValidateCredCard(dataCard?.data[0]?.expirationDate);
        setFlagCardLabel(dataCard?.data[0]?.flag);
        setFlagCard(dataCard?.data[0]?.flag);

        setZipCodeCard(dataCard?.data[0]?.zipCode);
        setCityCard(dataCard?.data[0]?.city);
        setStateIdCard(dataCard?.data[0]?.state);
        setlogradouroCard(dataCard?.data[0]?.logradouro);

        const user = await UserAccountsService.getUserAccountsByLogin();

        console.log('Userr', user);

        if (user.data.cep === dataCard.data[0].zipCode) {
          setUseUserAddress(true);
        }
      }
    }
  };

  const loadData = async () => {
    try {
      NProgress.start();
      setUserAccount(await UserAccountsService.getUserAccountsByLogin());
      const settingsResponse =
        await SettingsService.getSettingsByUserAccountParameters();

      const settingsByUserData = await SettingsService.getSettingsByUser();

      if (settingsResponse.responseStatus === 200) {
        console.log('settingsResponse', settingsResponse.data);

        if (settingsResponse?.data?.parameterization) {
          setCompletedStepParametrization(true);
          setPercentStep((prev) => prev + 1);
        }

        if (settingsResponse?.data?.clientes) {
          setCompletedStepAddClients(true);
          setPercentStep((prev) => prev + 1);
        }

        if (settingsResponse?.data?.members) {
          setCompletedStepAddTeamMembers(true);
          setPercentStep((prev) => prev + 1);
        }

        if (settingsResponse?.data?.campaigns) {
          setCompletedStepCreateCampaign(true);
          setPercentStep((prev) => prev + 1);
        }

        if (settingsResponse?.data?.publications) {
          setCompletedStepAddNewPost(true);
          setPercentStep((prev) => prev + 1);
        }
        if (settingsResponse?.data?.singlePost) {
          setCompletedSinglePost(true);
          setPercentStep((prev) => prev + 1);
        }
        if (settingsResponse?.data?.ownSchedule) {
          setCompletedOwnSchedule(true);
          setPercentStep((prev) => prev + 1);
        }
      }
      const userSubscription =
        await SubscriptionService.getSubscriptionByUser();
      const activeSubscriptionResponse =
        await SubscriptionService.getActiveSubscription();
      const userSubscriptionFeatures =
        await SubscriptionService.getSubscriptionFeatures();
      const currentSubscription =
        activeSubscriptionResponse?.data ?? getCurrentSubscription(userSubscription?.data);

      if (currentSubscription) {
        const planValue = parseFloat(currentSubscription.Plan.price);
        const expirationDate = new Date(currentSubscription.expiration);
        expirationDate.setHours(expirationDate.getHours() + 3);
        const formattedPrice = planValue.toLocaleString(
          country == 'br' ? 'pt-BR' : 'en-US',
          {
            style: 'currency',
            currency: country == 'br' ? 'BRL' : 'USD',
          },
        );
        const formattedMonth = (expirationDate.getMonth() + 1)
          .toString()
          .padStart(2, '0');
        const formattedDate = `${expirationDate
          .getDate()
          .toString()
          .padStart(2, '0')}/${formattedMonth}/${expirationDate.getFullYear()}`;

        if (settingsByUserData.responseStatus === 200) {
          let companyName = settingsByUserData.data?.userAccount?.fantasyName
            ? settingsByUserData.data?.userAccount?.fantasyName
            : settingsByUserData.data.name;
          if (settingsByUserData.data?.userAccount?.corporateName) {
            companyName = settingsByUserData.data?.userAccount?.corporateName;
          } else if (settingsByUserData.data?.name) {
            companyName =
              settingsByUserData.data?.name +
              ' ' +
              settingsByUserData.data?.surname;
          }
          // const initPlan = formatDate(planData.data[0].planStartedIn)
          // const endPlan = formatDate(planData.data[0].planEndIn)

          // let period = planData.data[0].planTypeId == 0 ? 'Ilimitado' : `${initPlan} até ${endPlan}`;

          setCompanyData({
            companyName: companyName,
            companyEmail: settingsByUserData.data?.email,
            companyPlan: currentSubscription
              ? currentSubscription.Plan.description
              : '',
            companyValue: formattedPrice ?? '',
            companyPeriod: formattedDate ?? '',
          });
          // console.log('291 userSubscriptionFeatures', userSubscriptionFeatures)
          setFeatureData(
            buildFeatureData(
              userSubscriptionFeatures,
              userSubscription,
              userPlan,
            ),
          );
        }
      } else {
        setCompanyData({
          companyName: settingsByUserData.data?.userAccount?.fantasyName
            ? settingsByUserData.data?.userAccount?.fantasyName
            : settingsByUserData.data.name,
          companyEmail: settingsByUserData.data?.email,
          companyPlan: 'Plano Free',
          companyValue: country == 'br' ? 'R$ 00,00' : '$ 00,00',
          companyPeriod: '--',
        });

        setFeatureData(
          buildFeatureData(
            userSubscriptionFeatures,
            userSubscription,
            userPlan,
          ),
        );
      }
    } catch (error) {
      console.error('Erro ao carregar dados', error);
    } finally {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            NProgress.done();
          }, 200);
        });
      });
    }
  };

  useEffect(() => {
    loadTimeline();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = addLeadingZero(date.getDate());
    const month = addLeadingZero(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = addLeadingZero(date.getHours());
    const minutes = addLeadingZero(date.getMinutes());
    const secconds = addLeadingZero(date.getSeconds());
    return `${day}/${month}/${year} ${hours}:${minutes}:${secconds}`;
  };
  const addLeadingZero = (value) => {
    return value < 10 ? `0${value}` : value;
  };

  const loadTimeline = async () => {
    try {
      const { data, responseStatus } =
        await TimelineActionsService.getTimelineActionAllData();

      setTimelineActionData(
        data?.map((item) => ({
          userName: item.UserAccount.user.name,
          clientName: item.BusinessClient?.companyName,
          timelineAction: item.timelineActionsValue,
          date: formatDate(item.createdAt),
          guestName: item.UserAccountBusinessUsers
            ? item.UserAccountBusinessUsers.name
            : null,
        })),
      );
    } catch (error) {
      console.error('Erro ao carregar timeline', error);
    }
  };

  const onFileChange = (e) => {
    Array.from(e.target.files).forEach((file) => {
      const reader = new FileReader();

      reader.onload = function () {
        let fileDataBase64 = reader.result;
        let fileDataReturn = {
          fileUrl: fileDataBase64,
          isBase64: true,
          status: 'create',
          fileName: file.name,
          fileFormat: file.type,
          fileContentType: 'image/' + file.type,
        };

        setUserImageData(() => [fileDataReturn]);
      };

      reader.readAsDataURL(file);
    });
  };

  const navigate = useNavigate();

  const navigationPage = (page) => {
    if (page === 'TimeLinePage') navigate('/TimeLinePage');
    if (page === 'PlanPage') navigate('/PlanCheckoutUser');
  };

  //const [creditCardNumber, setCreditCardNumber] = React.useState('')

  const formatCreditCardNumber = (e) => {
    e.preventDefault(); // Previne o comportamento padrão
    const inputValue = e.target.value;

    // Verifica o tamanho máximo (incluindo espaços)
    if (inputValue.length > 19) {
      return;
    }

    // Remove qualquer caractere que não seja número
    const numericValue = inputValue.replace(/\D/g, '');

    // Divide o número em grupos de 4 dígitos
    const formattedValue = numericValue.replace(/(\d{4})/g, '$1 ').trim();

    // Atualiza apenas um estado
    setNumberCredCard(formattedValue);
    setNumberCredCardValue(numericValue); // Se realmente precisar do valor sem formatação
  };

  const formatValidateNumber = (inputValue) => {
    // Remove qualquer caractere que não seja número

    if (inputValue.length === 5) {
      setValidateCredCard(inputValue);
    } else {
      const numericValue = inputValue.replace(/\D/g, '');

      // Limita a 6 dígitos
      const limitedValue = numericValue.slice(0, 4);
      let formattedValue;

      if (limitedValue.length >= 2) {
        // Verifica se os dois primeiros números são válidos (entre 1 e 12)
        const firstTwoDigits = parseInt(limitedValue.slice(0, 2), 10);
        if (firstTwoDigits < 1 || firstTwoDigits > 12) {
          // Trunca para dois dígitos válidos
          formattedValue = limitedValue.slice(0, 2);
        }
      }
      // Adiciona a máscara "00/0000"

      if (inputValue.length >= 4) {
        formattedValue = limitedValue
          .replace(/^(\d{2})/, '$1') // Adiciona a barra após os dois primeiros dígitos
          .replace(/(\d{2})(\d{0,2})/, '$1/$2'); // Adiciona a barra após os próximos dois dígitos
      }
      // Atualiza o estado com o valor formatado
      setValidateCredCard(formattedValue);
    }
  };

  const formatCcvNumber = (inputValue) => {
    if (inputValue.length > 3) {
      return;
    }
    const numericValue = inputValue.replace(/\D/g, '');

    setCvvCredCard(numericValue);
  };

  const cardTypes = [
    { name: 'Visa', value: 'visa', regex: /^4/ },
    { name: 'Mastercard', value: 'mastercard', regex: /^5[1-5]/ },
    { name: 'Amex', value: 'amex', regex: /^3[47]/ },
    { name: 'Diners', value: 'diners', regex: /^3(?:0[0-5]|[68])/ },
    { name: 'Discover', value: 'discover', regex: /^6(?:011|5)/ },
    { name: 'JCB', value: 'jcb', regex: /^(?:2131|1800|35)/ },
    { name: 'Aura', value: 'aura', regex: /^50(?:[0-9]{2})/ },
    { name: 'Hipercard', value: 'hipercard', regex: /^(606282|3841[046])/ },
  ];
  const detectCardType = (number) => {
    const card = cardTypes.find((card) => card.regex.test(number));
    setFlagCard(card ? card.value : '');
    setFlagCardLabel(card ? card.name : '');
  };
  // console.log('flagcard',flagCard, 'flagCArdLabel', flagCardLabel)
  // console.log('numberCredCard',numberCredCard, 'numberCredCardValue', numberCredCardValue)
  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Remove caracteres não numéricos

    detectCardType(value);
  };

  const handleInputChange = (e, type) => {
    e.preventDefault();

    if (type === 'credCard') {
      formatCreditCardNumber(e);
      handleChange(e);
    }
    if (type === 'validate') {
      formatValidateNumber(e.target.value);
    }
    if (type === 'cvv') {
      formatCcvNumber(e.target.value);
    }
  };

  const renderTimeline = () => {
    return timelineActionData.map((item, index) =>
      item.guestName ? (
        <div key={index} className={styles.data}>
          <div>
            <div className={styles.circle} />
          </div>
          <p className={`${styles.data_label}`}>
            O usuário convidado{' '}
            <span className={styles.boldText}>{item.guestName} </span>
            {item.timelineAction} {item.clientName ? 'para o cliente ' : ' '}
            <span className={styles.boldText}>{item.clientName}</span>
          </p>
          <p className={styles.data_content}>{item.date}</p>
        </div>
      ) : (
        <div key={index} className={styles.data}>
          <div>
            <div className={styles.circle} />
          </div>
          <p className={`${styles.data_label}`}>
            O usuário <span className={styles.boldText}>{item.userName} </span>
            {item.timelineAction} {item.clientName ? 'para o cliente ' : ' '}
            <span className={styles.boldText}>{item.clientName}</span>
          </p>
          <p className={styles.data_content}>{item.date}</p>
        </div>
      ),
    );
  };
  function onlyNumbers(input) {
    return input.replace(/[^0-9]/g, '');
  }

  const validFieldsCard = async (input) => {
    return input.replace(/[^0-9]/g, '');
  };

  const handleSavePaymentData = async () => {
    // const data = await PagarMeService.getCardByUser();
    const data = { data: [] };

    validFieldsCard();

    const body = {
      uuid: data?.data[0]?.uuid,
      userAccountId: userAcount?.data?.uuid,
      cardToken: `${cvvCredCard}`,
      cardName: `${nameCredCard}/${userAcount?.data?.cnpj}`,
      flag: flagCard,
      number: `${numberCredCardValue}`,
      expirationDate: validateCredCard.replace(/(\d{2})\/(\d{2})/, '$1/20$2'),
      // expirationDate: validateCredCard,
      type: 'CREDIT',
      logradouro: logradouroCard,
      zipCode: onlyNumbers(zipCodeCard),
      city: cityCard,
      stateId: stateIdCard,
      country: !countryCard ? 'BR' : countryCard,
    };

    if (data?.data?.length > 0) {
      // await PagarMeService.postCard(body);
      localStorage.setItem('userCardInfo', JSON.stringify([{}]));
    } else {
      const { uuid, ...rest } = body;

      // await PagarMeService.postCard(rest);
      localStorage.setItem('userCardInfo', JSON.stringify([{}]));
    }
  };

  const formatDateLog = (inputDate) => {
    const date = new Date(inputDate);
    const day = date.getDate();
    const monthIndex = date.getMonth();

    const months = [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ];

    const month = months[monthIndex];

    return `${day} de ${month}`;
  };

  const handleCloseModal = (modal) => {
    if (modal === 'galeria') {
      setModalOpen(false);
    }
  };
  const handleOpenModal = (modal) => {
    if (modal === 'galeria') {
      setModalOpen(true);
    }
  };

  const teste = {
    height: '100px',
    width: '100%',
    'overflow-y': 'scroll',
  };
  const storage = JSON.parse(window.localStorage.getItem('userData')).userEmail;
  const userInfo = {
    username: storage, // REQUIRED, must be unique
  };

  const [showTutorial, setShowTutorial] = useState(false);
  const timerToStartTutorial = useRef(null);

  const handleAnimateComplete = () => {
    if (localStorage.getItem('showTutorialDashboard') !== 'false') {
      timerToStartTutorial.current = setInterval(() => {
        setShowTutorial(true);
      }, 500);
    }
  };

  const handleFinishTutorial = () => {
    localStorage.setItem('showTutorialDashboard', false);
    setShowTutorial(false);
    clearInterval(timerToStartTutorial.current);
    timerToStartTutorial.current = null;
  };
  return (
    <motion.div
      // key={expanded}
      initial={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{ width: '100%' }}
      onAnimationComplete={() => handleAnimateComplete()}
    >
      {showTutorial && (
        <TourGuide
          isOpen={showTutorial}
          onFinish={() => handleFinishTutorial()}
          steps={DashboardContainerSteps.map((e, i) => ({
            ...e,
            content: t(e.content),
            locale:
              DashboardContainerSteps.length === i + 1
                ? {
                  back: t(e.locale.back),
                  close: t(e.locale.close),
                  skip: t(e.locale.skip),
                }
                : {
                  close: t(e.locale.next),
                  next: t(e.locale.next),
                  back: t(e.locale.back),
                  skip: t(e.locale.skip),
                },
          }))}
        />
      )}

      <div className={styles.page}>
        <div className={styles.title_my_data}>
          <p className={styles.title_my_data_label}>{t('settings.title')}</p>
          <p className={styles.title_my_data_title}>{t('my_account.subtitle')}</p>
        </div>

        <div className={styles.container_page}>
          <SideMenuMyAccount />

          <div className={styles.settings_main}>
        <div className={styles.container_box_image}>
          <ModalComponent
            isOpen={isModalOpen}
            onClose={() => handleCloseModal('galeria')}
          // className={teste}
          >
            <ModalCancelPlan
              // setImageAIArray={setImageAIArray}
              onClose={() => handleCloseModal('galeria')}
              handleCloseModal={handleCloseModal}
            />
          </ModalComponent>
        </div>

        <div className={styles.container_system_Settings}>
          <Masonry columnsCount={2} gutter="10px">
            <div id="account-info" className={styles.box_company_card}>
              <div className={styles.box_company}>
                <div className={styles.box_image_user_upload}>
                  <img
                    className={styles.image_user_upload}
                    src={
                      userImageData[0] !== undefined
                        ? userImageData[0]?.fileUrl
                        : companyIcon
                    }
                    alt=""
                  //onContextMenu={(e) => e.preventDefault()}
                  />
                  <div className={styles.button_user_upload}>
                    <label htmlFor="arquivo">
                      <PencilUploadIcon
                        color={'#FF8B00'}
                        colorPen={''}
                        width={30}
                        height={30}
                      />
                    </label>
                    <input
                      type="file"
                      name="arquivo"
                      id="arquivo"
                      onChange={(e) => onFileChange(e)}
                    ></input>
                  </div>
                </div>
                <div className={styles.box_title_conpany}>
                  <p className={styles.title_card}>{companyData.companyName}</p>
                  <p className={styles.email_company}>@nomedaempresa</p>
                </div>
              </div>
              <div>
                <div className={styles.data}>
                  <p className={styles.data_label}>
                    {t('settings.company.email')}
                  </p>
                  <p className={styles.data_content}>
                    {companyData.companyEmail}
                  </p>
                </div>

                <div className={styles.data}>
                  <p className={styles.data_label}>
                    {t('settings.company.username')}
                  </p>
                  <p className={styles.data_content}>
                    {companyData.companyName}
                  </p>
                </div>

                <div className={styles.data}>
                  <p className={styles.data_label}>
                    {t('settings.company.plan')}
                  </p>
                  <p className={styles.data_content}>
                    {companyData.companyPlan}
                  </p>
                </div>

                <div className={styles.data}>
                  <p className={styles.data_label}>
                    {t('settings.company.plan_value')}
                  </p>
                  <p className={styles.data_content}>
                    {companyData.companyValue}
                  </p>
                </div>

                <div className={styles.data}>
                  <p className={styles.data_label}>
                    {t('settings.company.period')}
                  </p>
                  <p className={styles.data_content}>
                    {companyData.companyPeriod}
                  </p>
                </div>
              </div>
              {/* <div className={styles.box_button}>
                <button
                  className={styles.button_change_payment_data}
                  onClick={() => navigationPage("PlanPage")}
                >
                  {t("settings.company.buttons.upgrade")}
                </button>
                <button
                  className={styles.button_cancel_payment_data}
                  onClick={() => handleOpenModal("galeria")}
                >
                  {t("settings.company.buttons.cancel")}
                </button>
              </div> */}
            </div>

            {/* Timeline */}

            <div id="timeline-info" className={styles.box_company_card}>
              <div className={styles.box_title_card}>
                <p className={styles.title_card}>
                  {t('settings.timeline.title')}
                </p>
              </div>
              <div>
                { }

                {renderTimeline()}
              </div>

              <button
                className={styles.button_settings}
                onClick={() => navigationPage('TimeLinePage')}
              >
                {t('settings.timeline.see_more')}
              </button>
            </div>

            {/* <div id="config-info" className={styles.box_company_card}>
              <div className={styles.box_title_card}>
                <p className={styles.title_card}>{`${t(
                  "settings.setup.title",
                )} (${percentStep}/5)`}</p>

                <ProgressBar percent={percentStep * 20} />
              </div>

              <Stepper
                size={"50px"}
                completedStepParametrization={completedStepParametrization}
                completedStepAddClients={completedStepAddClients}
                completedStepAddTeamMembers={completedStepAddTeamMembers}
                completedStepCreateCampaign={completedStepCreateCampaign}
                completedStepAddNewPost={completedStepAddNewPost}
                completedOwnSchedule={completedOwnSchedule}
                completedSinglePost={completedSinglePost}
              />
            </div> */}

            {/*Features*/}
            <div id="feature-info" className={styles.box_company_card}>
              <div className={styles.box_title_card}>
                <p className={styles.title_card}>
                  {t('settings.features.title')}
                </p>
              </div>

              <div
                className={styles.container_features}
                style={{
                  overflow: 'auto',

                  scrollbarWidth: 'thin',
                  '&::-webkit-scrollbar': {
                    width: '6px',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: '#f1f1f1',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#888',
                    borderRadius: '4px',
                  },

                  // paddingLeft: "180px",
                  padding: '20px',
                }}
              >
                <div className={styles.box_features}>
                  <div className={styles.features}>
                    <p className={styles.current_number}>
                      {featureData.productQuantity}
                    </p>
                    <p className={styles.total_number}>
                      /{featureData.productQuantityLimit}
                    </p>
                  </div>
                  <div className={styles.features_title}>
                    {t('settings.features.product.title')}
                  </div>
                </div>

                {/* <div className={styles.box_features}>
                  <div className={styles.features}>
                    <p className={styles.current_number}>
                      {featureData.targetAudienceQuantity}
                    </p>
                    <p className={styles.total_number}>
                      /{featureData.targetAudienceQuantityLimit}
                    </p>
                  </div>
                  <div className={styles.features_title}>
                    {t('settings.features.target_audience.title')}
                  </div>
                </div> */}

                <div className={styles.box_features}>
                  <div className={styles.features}>
                    <p className={styles.current_number}>
                      {featureData.userQuantity}
                    </p>
                    <p className={styles.total_number}>
                      /{featureData.userQuantityLimit}
                    </p>
                  </div>
                  <div className={styles.features_title}>
                    {t('settings.features.users.title')}
                  </div>
                </div>

                <div className={styles.box_features}>
                  <div className={styles.features}>
                    <p className={styles.current_number}>
                      {featureData.showCampaignCounter
                        ? featureData.campaignTrialAvailable
                          ? 0
                          : 1
                        : featureData.artGenerationCount}
                    </p>
                    <p className={styles.total_number}>
                      /
                      {featureData.showCampaignCounter
                        ? 1
                        : featureData.SinglePostLimit}
                    </p>
                  </div>
                  <div className={styles.features_title}>
                    {featureData.showCampaignCounter
                      ? t('settings.features.campaigns')
                      : t('settings.features.arts')}
                  </div>
                </div>

                {/* <div className={styles.box_features}>
                  <div className={styles.features}>
                    <p className={styles.current_number}>
                      {featureData.postQuantity}
                    </p>
                    <p className={styles.total_number}>
                      /{featureData.postQuantityLimit}
                    </p>
                  </div>
                  <div className={styles.features_title}>
                    {t('settings.features.posts.title')}
                  </div>
                </div> */}

                <div className={styles.box_features}>
                  <div className={styles.features}>
                    <p className={styles.current_number}>
                      {featureData.schedullingQuantity}
                    </p>
                    <p className={styles.total_number}>
                      /{featureData.schedullingQuantityLimit}
                    </p>
                  </div>
                  <div className={styles.features_title}>
                    {featureData.unlimitedScheduling
                      ? 'Agendamentos ilimitados'
                      : t('settings.features.schedules.title')}
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.box_company_card}>
              <InviteLinkComponent />
            </div>
          </Masonry>
        </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Settings;
